module.exports = __webpack_public_path__ + "img/kakuyomu.5b1cb6b2.svg";